export enum LineEventType {
  DrawingStarted = 'drawingStarted',
  DrawingEnd = 'drawingEnd',
  DashedLineDeleted = 'dashedLineDeleted',
  LineCreated = 'lineCreated',
  VertexAddedInLine = 'vertexAddedInLine',
  EditingLockChanged = 'editingLockChanged',
}
